import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAtAndTComponent } from './simple-icons-at-and-t.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAtAndTComponent ],
    exports:      [ SimpleIconsAtAndTComponent ],
    bootstrap:    []
})
export class SimpleIconsAtAndTModule {}
